import { render } from "./CookiebarCategory.ce.vue?vue&type=template&id=8f662f00"
import script from "./CookiebarCategory.ce.vue?vue&type=script&lang=js"
export * from "./CookiebarCategory.ce.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__